import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import * as _ from 'lodash-es';
import { JsonObjectFactoryService } from '../../shared/_services/json-object-factory.service';

@Injectable({
  providedIn: 'root'
})
export class PartnerAllocationsService {
  constructor(private jsonObjectFactoryService: JsonObjectFactoryService) {}

  saveAllocationAmounts(
    baseUrl: string,
    data: any,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    if (!data?.rowData || !data?.colData?.map) return of({ callSuccess: '0', errorMessage: 'Invalid payload' });

    const row = data.rowData;
    const jsonObj = [{
      combination_key: row.COMBINATION_KEY,
      acct_key: row[`${data.colData.map}_ACCT_KEY`],
      amount: row[data.colData.map],
      ptr_combination_key: row.PTR_COMBINATION_KEY
    }];
    const jsonSettings = [{
      tax_year: filterParams?.tax_year,
      combination_key: row.COMBINATION_KEY
    }];

    const params = _.merge({}, globalService?.globalParams || globalService || {}, filterParams, {
      jsonObj: JSON.stringify(jsonObj),
      jsonSettings: JSON.stringify(jsonSettings)
    });
    return this.jsonObjectFactoryService.saveJSON6(
      `${baseUrl}/saveJsonObject?action_code=ddzypk`,
      params,
      globalService,
      filterParams
    );
  }
}
